import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { installAuthHooks } from './api/client';
import { useAuthStore } from './stores/authStore';
import './styles/tokens.css';
import './styles/infoTooltip.css';
import './shell/shell.css';

// axios interceptor 가 authStore 와 router 에 접근할 수 있도록 hook 주입.
installAuthHooks({
  getAccessToken: () => useAuthStore.getState().accessToken,
  setAccessToken: (token) => useAuthStore.getState().setAccessToken(token),
  clear: () => useAuthStore.getState().clear(),
  redirectToLogin: () => {
    // React Router 외부에서 강제 리다이렉트.
    const current = window.location.pathname + window.location.search;
    const isOnLogin = window.location.pathname.startsWith('/login');
    if (!isOnLogin) {
      const target = `/login?redirect_to=${encodeURIComponent(current)}`;
      window.location.replace(target);
    }
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
